let originalHTML = "";
let container = null;

function toMobileExistingTables(tablesArray) {
    const colCount = 3;
    const mobileTables = [];

    if (!originalHTML) {
        container = tablesArray[0].parentNode;
        originalHTML = container.innerHTML;
    }

    for (let i = 0; i < colCount; i++) {
        const mt = document.createElement("table");
        mt.classList.add("table--mobile");
        mt.style.width = "100%";
        const mtbody = document.createElement("tbody");
        mt.appendChild(mtbody);
        mobileTables.push({ table: mt, tbody: mtbody });
    }


    tablesArray.forEach(table => {
        const tbodies = table.querySelectorAll("tbody");

        tbodies.forEach(tbody => {
            const rows = tbody.querySelectorAll("tr");
            rows.forEach(row => {
                const cells = row.querySelectorAll("td");
                cells.forEach((cell, colIndex) => {
                    if (mobileTables[colIndex]) {
                        const tr = document.createElement("tr");
                        tr.appendChild(cell.cloneNode(true));
                        mobileTables[colIndex].tbody.appendChild(tr);
                    }
                });
            });
        });
    });
    container.innerHTML = "";
    mobileTables.forEach(mt => container.appendChild(mt.table));
}

function toDesktopExistingTables() {
    if (originalHTML && container) {
        container.innerHTML = originalHTML; 
    }
}

function updateTables() {

    const allTables = Array.from(document.querySelectorAll(".otnotice-section-content table"));
    if (allTables.length < 4) return;
    const targetTables = allTables.slice(6 , 10);

    if (window.innerWidth < 1024) {
        toMobileExistingTables(targetTables);
    } else {
        toDesktopExistingTables();
    }
}

function initTablesOnceReady() {
    if (document.querySelectorAll(".otnotice-section-content table").length) {
        updateTables();
        window.addEventListener("resize", updateTables);
    } else {
        const poller = setInterval(() => {
            if (document.querySelectorAll(".otnotice-section-content table").length) {
                clearInterval(poller);
                updateTables();
                window.addEventListener("resize", updateTables);
            }
        }, 300);
    }
}

if (document.readyState !== "loading") {
    initTablesOnceReady();
} else {
    document.addEventListener("DOMContentLoaded", initTablesOnceReady);
}